import { render, staticRenderFns } from "./channel-private-button.vue?vue&type=template&id=baa19dc2"
import script from "./channel-private-button.vue?vue&type=script&lang=js"
export * from "./channel-private-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports